import React from 'react';
import { Route } from 'react-router-dom';
import Guardians from '../pages/guardians/Guardians';
import GuardiansArchive from '../pages/guardians/GuardiansArchive';
import CreateGuardian from '../pages/guardians/CreateGuardian';
import EditGuardian from '../pages/guardians/EditGuardian';
import PermissionGuard from '../components/global/PermissionGuard';

const guardiansRoutes = (
    <>
        <Route path="/guardians" element={<PermissionGuard permission="guardians_list"><Guardians /></PermissionGuard>} />
        <Route path="/guardians/archive" element={<PermissionGuard permission="guardians_archive_list"><GuardiansArchive /></PermissionGuard>} />
        <Route path="/guardians/create" element={<PermissionGuard permission="guardians_create"><CreateGuardian /></PermissionGuard>} />
        <Route path="/guardians/:id/edit" element={<PermissionGuard permission="guardians_edit"><EditGuardian /></PermissionGuard>} />
    </>
);

export default guardiansRoutes;
